/** Progressively enhance the ordinary email signup form without storing the address. */
export function initEmailCapture(): void {
  document.querySelectorAll<HTMLFormElement>('[data-email-capture]').forEach((form) => {
    if (form.dataset['initialized'] === 'true') return;
    form.dataset['initialized'] = 'true';

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (form.dataset['submitting'] === 'true') return;
      void submit(form);
    });
  });
}

async function submit(form: HTMLFormElement): Promise<void> {
  const button = form.querySelector<HTMLButtonElement>('button[type="submit"]');
  const status = form.querySelector<HTMLElement>('[data-email-status]');
  if (button === null || status === null) return;

  const fields = new FormData(form);
  // Campaign labels only. No full URL, referrer, email, or arbitrary form values in analytics.
  if ((navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl !== true) {
    const query = new URLSearchParams(window.location.search);
    for (const name of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content']) {
      const value = query.get(name);
      if (value !== null && /^[a-zA-Z0-9_-]{1,100}$/.test(value)) {
        fields.set(`subscription[utm][${name}]`, value);
      }
    }
  }

  form.dataset['submitting'] = 'true';
  button.disabled = true;
  button.textContent = 'Saving…';
  status.hidden = true;

  try {
    const response = await fetch(form.action, {
      method: 'POST',
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
      body: fields,
      credentials: 'same-origin',
    });
    const result: unknown = await response.json();
    const payload = result as { ok?: boolean; message?: unknown; track_request?: boolean } | null;
    const message = typeof payload?.message === 'string' ? payload.message : undefined;

    if (!response.ok || payload?.ok !== true) {
      status.textContent = message ?? "We couldn't save your signup. Please try again.";
      return;
    }

    const content = form.querySelector<HTMLElement>('[data-email-fields]');
    if (content !== null) content.hidden = true;
    form.reset();
    status.textContent = message ?? 'Your signup request has been received.';
    const eventName = form.dataset['successEvent'];
    if (
      payload.track_request !== false &&
      eventName !== undefined &&
      window.dataLayer !== undefined
    ) {
      window.dataLayer.push({ event: eventName, cta: 'ops_notes' });
    }
  } catch {
    status.textContent =
      "We couldn't save your signup. Check your connection, refresh this page, and try again.";
  } finally {
    form.dataset['submitting'] = 'false';
    button.disabled = false;
    button.textContent = 'Subscribe';
    status.hidden = false;
    status.focus();
  }
}
